<template>
  <div id="fiveG">
    <div class="header">
      <img src="../assets/5g1.png" alt class="img1" />
    </div>
    <div class="content">
      <img src="../assets/5g2.png" alt style="margin-top:-1px" class="img1" />
    </div>
    <div class="footer">
      <img src="../assets/5g3.png" alt class="img1" style="margin-top:-1px" />
      <div class="last">
        <div>
          <input
            type="text"
            placeholder="请输入联系人姓名"
            v-model="contract_name"
            @blur="blur()"
            maxlength="10"
          />
        </div>
        <div>
          <input type="text" placeholder="请选择工作类型" @click="chooseTpye" v-model="value1" readonly />
          <img src="../assets/5g4.png" alt class="png" />
        </div>
        <div>
          <input
            type="text"
            placeholder="请输入工作类型"
            maxlength="15"
            v-model="mark"
            v-if="gongzuo"
            @blur="blur()"
          />
        </div>
        <div>
          <input
            class="phone"
            placeholder="请输入联系人手机号"
            v-model="phone"
            type="text"
            maxlength="11"
            @blur="blur()"
          />
        </div>
        <div>
          <input
            type="text"
            placeholder="请输入6位手机验证码"
            class="four"
            v-model="code"
            @blur="blur()"
            maxlength="6"
          />
          <button id="codeText" class="btn" v-on:click="codebtn()" style="text-align:center">获取验证码</button>
        </div>
        <button class="btn1" @click="submit()">提交</button>
      </div>
      <div></div>
    </div>

    <SPicker :show="showPicker" type="3" @selectedSPicker="selectedSPicker"></SPicker>
  </div>
</template>

<script>
import SPicker from '../components/single-picker'
import wxShare from '../wx/weixin.js'

// 引入
import { Toast } from 'mint-ui'
export default {
  data () {
    return {
      phone: '',
      contract_name: '',
      code: '',
      work_type: '',
      showPicker: false,
      gongzuo: false,
      value1: '',
      mark: '',
      binCode: 0
    }
  },
  methods: {
    blur: function () {
      if (this.utils.isIphone()) { // iphone 适配键盘 弹出 回弹
        const currentScrollY = window.scrollY
        window.scrollTo(0, currentScrollY)
      }
    },
    isMobile () {
      let rex = /^1[3456789]\d{9}$/g
      return rex.test(this.phone)
    },
    checkIsMobile () {
      // this.phone = this.phone.replace(/\D/g, '')
      console.log('=================' + this.phone)
      if (this.phone.length === 11) {
        if (!this.isMobile()) {
          Toast('请输入正确的手机号')
          return false
        }
      }
    },
    codebtn: function () {
      if (!this.isMobile()) {
        Toast('请输入正确的手机号')
        return false
      }
      if (this.binCode === 1) {
        Toast('该手机号已存在,请更换手机号报名!')
        return
      }
      // 发送验证码的操作
      this.utils.POST(
        this.accountUrl + '/account/sendsms',
        { phone: this.phone },
        resj => {
          Toast('发送成功')
          this.countDown()
        }
      )
    },
    countDown: function () { // 倒计时
      console.log('倒计时==========')
      var that = this
      var maxtime = 60
      this.timer = setInterval(function () {
        if (maxtime > 0) {
          --maxtime
          document.getElementById('codeText').innerText = '已发送(' + maxtime + 's)'
        } else {
          clearInterval(that.timer)
          document.getElementById('codeText').innerText = '获取验证码'
        }
      }, 1000)
    },
    selectedSPicker: function (value) {
      console.log(value)
      this.showPicker = false
      this.value1 = value.text
      this.work_type = value.id
      if (this.value1 === '其他') {
        this.gongzuo = true
      } else {
        this.gongzuo = false
        this.mark = ''
      }
    },
    checkName () {
      if (this.contract_name === '') {
        Toast('姓名不能为空')
      }
    },
    chooseTpye () {
      this.showPicker = true
    },
    submit () {
      console.log(this.code.length, 66666666666)
      if (this.contract_name === '') {
        Toast('姓名不能为空')
        return false
      }
      if (this.value1 === '') {
        Toast('请选择工作类型')
        return false
      }
      if (this.value1 === '其他' && this.mark === '') {
        Toast('工作类型不能为空')
        return false
      }
      if (this.phone.length <= 0) {
        Toast('手机号不能为空')
        return false
      }
      if (this.code.length <= 0) {
        Toast('验证码不能为空')
        return false
      } else {
        this.utils.POST(
          this.accountUrl + '/account/verifyCode', { phone: this.phone, code: this.code },
          resj => {
            var data = resj.data.data
            if (data === false || data === '验证码已过期，请点击重新发送') {
              Toast('验证码错误，请重新输入')
              return false
            } else {
              var json = JSON.stringify({ contract_name: this.contract_name, contract_phone: this.phone, work_type: this.work_type, mark: this.mark })
              this.utils.POSTHeaderQS(
                this.accountUrl + '/emergencyForum/signUp', { 'Content-Type': 'application/json' }, false, json,
                resj => {
                  if (resj.code === 0) {
                    Toast('信息已提交成功，我们会尽快与您联系')
                    this.contract_name = ''
                    this.phone = ''
                    this.work_type = ''
                    this.mark = ''
                    this.value1 = ''
                    this.code = ''
                    clearInterval(this.timer)
                    document.getElementById('codeText').innerText = '获取验证码'
                  }
                }
              )
            }
          }
        )
      }
    },
    isSubmit: function () {
      var _this = this
      this.utils.GET(this.accountUrl + '/emergencyForum/repeatCheck?contract_phone=' + this.phone, function (response) {
        _this.binCode = 0
        if (parseInt(response.data) === 0) {
          _this.binCode = 1
        }
      })
    }
  },
  watch: {
    phone: function (val) { // 检测
      this.phone = val.replace(/[^\d]/g, '')
      if (this.phone.length === 11) {
        if (!this.utils.isPhone(this.phone)) {
          Toast('请正确输入手机号')
        } else {
          this.isSubmit()
        }
      }
    },
    code: function (val) {
      this.code = val.replace(/[^\d]/g, '')
    }
  },
  computed: { // 计算

  },
  components: {
    SPicker
  },
  mounted () {
    wxShare.wxRegister('5G时代，​世界应急救援消防安全高峰​论坛', '中消在线诚邀您加入！顶尖物联网专家构建安全生态圈，带动无限商机！', 'http://cdn.zxzx119.com/65935696367452160')
  }
}
</script>

<style lang="scss" scoped>
.img1 {
  display: block;
  width: 100%;
}
.footer {
  position: relative;
}
.last {
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
}
.last input {
  width: 320px;
  height: 50px;
  margin: 10px 0;
  line-height: 20px;
  background-color: #fff;
  /*border: 1px solid rgb(219, 204, 204);*/
  /*box-sizing: border-box;*/
  border-radius: 5px;
  /*padding-left: 20px;*/
  padding: 15px 10px;
  font-size: 14px;
}
input::-webkit-input-placeholder {
  color: #dedede;
}
.last .four {
  width: 200px;
  height: 50px;
}
.btn {
  width: 100px;
  height: 50px;
  text-align: center;
  background-color: #c41335;
  color: #fff;
  font-size: 14px;
  margin-left: 16px;
  border-radius: 5px;
}
.btn1 {
  width: 320px;
  height: 50px;
  background-color: #c41335;
  color: #fff;
  font-size: 14px;
  border-radius: 5px;
  margin-top: 20px;
}
#select {
  width: 320px;
  height: 50px;
  margin: 12px 0;
  background-color: #fff;
  /*border: 1px solid rgb(219, 204, 204);*/
  /*box-sizing: border-box;*/
  border-radius: 5px;
  padding-left: 20px;
  font-size: 14px;
}
/deep/ .van-picker__cancel {
  color: #333333;
}
.png {
  position: absolute;
  top: 102px;
  right: 15px;
  width: 10px;
  height: 7px;
}
</style>



// WEBPACK FOOTER //
// src/view/fiveG.vue